export const regexes = {
    onlyNumbers: { reg: /^[0-9]*$/, errorMsg: 'Please, type only numbers' },
    numbersAndDot: {
      reg: /^\d*\.?\d*$/,
      errorMsg: 'Only numbers and dot allowed'
    },
    textAndNumbers: {
      reg: /^[A-Za-z0-9]+$/,
      errorMsg: 'Only letters and numbers allowed'
    },
    numbersDotComma: {
      reg: /^[0-9]*[,.]?[0-9]*$/,
      errorMsg: 'Only numbers, one dot or one comma is allowed'
    }
  }